import { render } from "./uploadForm.vue?vue&type=template&id=8f214f34"
import script from "./uploadForm.vue?vue&type=script&lang=js"
export * from "./uploadForm.vue?vue&type=script&lang=js"

import "./uploadForm.vue?vue&type=style&index=0&id=8f214f34&lang=css"
script.render = render

export default script